export default {
  "content": "<path d=\"M20.5 20h-17v-2h17v2zM20.5 13h-17v-2h17v2zM20.5 6h-17V4h17v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};